
<!--引入例子 <input-number v-model="inputNumberValue" width="100" height="30" maxValue="35" minValue="28" unit="像素" @changeValue="changeValueTest"></input-number>-->
<!--v-model是值，maxValue和minValue是最大最小范围-->
<!--unit是单位，不需要显示为空即可-->
<!--width和height是输入框宽高-->
<!--changeValue是数值改变时的回调函数-->
<!--errorValue是数值错误的回调函数-->

<template>
  <v-text-field v-model="currValue" :suffix="unit" dark outlined hide-details :height="height"
                :style="{'width':width+'px'}" class="inputNumberTextField" @blur="inputValueChange">
    <template v-slot:append>
      <div style="font-size:13px;">
        <p @click="addValue" style="line-height:10px;color:#c4c4c4;cursor:pointer;" class="iconfontFamily">&#xe644;</p>
        <p @click="subValue" style="line-height:10px;color:#c4c4c4;cursor:pointer;" class="iconfontFamily">&#xe645;</p>
      </div>
    </template>
  </v-text-field>
</template>

<script>
export default {
  name: "InputNumber",
  model:{
    prop:"value",//用来接收 父组件 传给子组件的值
    event:"number-event" //用来触发的事件
  },
  props:["width","height","value","maxValue","minValue","unit"],
  data(){
    return{
      currValue:this.value
    }
  },
  watch:{
    value(){
      this.currValue = this.value
    }
  },
  methods:{
    addValue(){
      if(this.value < this.maxValue){
        this.$emit("number-event",parseFloat(this.value)+1);
        this.$emit("changeValue");
      }
      else{
        this.$emit("errorValue");
      }
    },
    subValue(){
      if(this.value > this.minValue){
        this.$emit("number-event",parseFloat(this.value)-1);
        this.$emit("changeValue");
      }
      else{
        this.$emit("errorValue");
      }
    },
    inputValueChange(){
      console.log(this.currValue)
      if(parseFloat(this.currValue) >= this.minValue && parseFloat(this.currValue) <= this.maxValue){
        this.$emit("number-event",parseFloat(this.currValue));
        this.$emit("changeValue");
      }
      else{
        this.currValue = this.value;
        this.$emit("errorValue");
      }
    }


  }

}
</script>

<style scoped>

.inputNumberTextField{
  font-size:13px;
  flex:none;
}

</style>


<style>

.inputNumberTextField .v-input__slot{
  min-height: inherit !important;
  padding:0 4px 0 6px !important;
}
.inputNumberTextField .v-input__append-inner{
  align-self:center;
  margin-top:0;
}

</style>